import { FC, SVGProps } from 'react';

const TrustlyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="25"
    viewBox="0 0 33 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* eslint-disable-next-line max-len */}
    <path d="M2.271 22.39v-6.317H0v-1.385h6.038v1.385h-2.27v6.317zm3.599 0v-5.593h1.388v.885c.36-.747.813-.885 1.297-.885h.544v1.4h-.475c-.706 0-1.328.408-1.328 1.647v2.539H5.87zm4.013-2.023v-3.562h1.427v3.223c0 .716.368 1.193 1.02 1.193.63 0 1.098-.477 1.098-1.185v-3.24h1.434v5.594h-1.38v-.708c-.361.562-.914.831-1.612.831-1.174 0-1.987-.784-1.987-2.146m5.73.439 1.259-.285c.061.492.46.823 1.128.823.544 0 .859-.23.859-.53 0-.247-.146-.408-.675-.54l-.906-.207c-1.059-.246-1.557-.746-1.557-1.677 0-.947.79-1.7 2.232-1.7 1.527 0 2.157.907 2.24 1.561l-1.258.277c-.06-.346-.322-.715-1.012-.715-.453 0-.79.207-.79.508 0 .261.199.407.506.484l1.227.293c.96.23 1.42.792 1.42 1.615 0 .9-.729 1.785-2.279 1.785-1.688 0-2.317-1.008-2.394-1.692m7.62 1.584c-.96 0-1.565-.547-1.565-1.57v-2.777h-.929v-1.247h.929V15.52l1.427-.408v1.685h1.135v1.247h-1.135v2.53c0 .409.2.57.614.57h.621v1.247zm2.025 0v-7.702h1.427v7.702zm6.153-5.593h1.535L30.59 24.39h-1.534l.652-2h-.775l-1.588-5.594h1.534l1.212 4.4zM8.6 5.178h5.502v-4.4l4.389 4.4-4.39 4.4v2.247h5.326V5.178h4.895V0H8.6z" fill="#000" />
  </svg>
);

export default TrustlyIcon;
